import { Calendar } from 'lucide-react';
import { InputTimeSelect, Modal, Toast } from '@/uiComponents/common';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { getLocale2 } from '@/helpers/dates';
import { putDateReservation } from '@/services';
import { useContext } from 'react';
import { WelletContext } from '@/context/wellet/welletContext';

export function EditScheduleModal({ isOpen, onClose, callback, date, reservationId }) {
  const { t } = useTranslation('translation', { keyPrefix: 'modals.modalSchedule' });
  const language = useSelector((state) => state.app.language);
  const welletContext = useContext(WelletContext);
  const locale = getLocale2(language);
  const methods = useForm({
    defaultValues: {
      time: date ? format(new Date(date), 'HH:mm', { locale }) : '',
    },
  });

  const onCloseModal = () => {
    onClose();
    methods.setValue('time', date ? format(new Date(date), 'HH:mm', { locale }) : '');
  };

  const onSubmit = (data) => {
    const [hours, minutes] = data.time.split(':').map(Number);
    const newDate = new Date(date);
    newDate.setHours(hours);
    newDate.setMinutes(minutes);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);

    const pad = (n) => String(n).padStart(2, '0');
    const formattedDate = `${newDate.getFullYear()}-${pad(newDate.getMonth() + 1)}-${pad(
      newDate.getDate(),
    )}T${pad(newDate.getHours())}:${pad(newDate.getMinutes())}:${pad(newDate.getSeconds())}`;

    changeScheduleMutation.mutate(formattedDate);
  };

  const changeScheduleMutation = useMutation({
    mutationFn: (data) => putDateReservation(welletContext, reservationId, data),
    onSuccess: () => callback(),
  });

  return (
    <FormProvider {...methods}>
      <form key={'schedule'}>
        <Modal
          title={
            <div className='tw-flex tw-items-center tw-gap-2'>
              <Calendar className='tw-h-5 tw-w-5' />
              <span>{t('title')}</span>
            </div>
          }
          open={isOpen}
          onClose={onCloseModal}
          maxWidth='450px'
          btnType='submit'
          isLoading={!changeScheduleMutation?.isIdle}
          textCancel={t('cancel')}
          textSubmit={t('submit')}
          handleSubmit={methods.handleSubmit(onSubmit)}
        >
          <div className='py-2 row'>
            <InputTimeSelect
              name={'time'}
              className={'col'}
              label={
                <>
                  <div className='d-flex tw-items-center tw-gap-1'>
                    <span>{t('time')}</span>
                  </div>
                </>
              }
            />
          </div>
        </Modal>
      </form>
      {changeScheduleMutation?.isSuccess ? (
        <Toast
          message={t('toast.success')}
          type={'SUCCESS'}
          onCallback={() => {
            changeScheduleMutation.reset();
            onCloseModal();
          }}
        />
      ) : null}
      {changeScheduleMutation?.isError ? (
        <Toast
          message={t('toast.error')}
          type={'ERROR'}
          onCallback={() => changeScheduleMutation.reset()}
        />
      ) : null}
    </FormProvider>
  );
}
